import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrPrestartJobcardPage } from './klmr-prestart-jobcard';

@NgModule({
  declarations: [
    KlmrPrestartJobcardPage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrPrestartJobcardPage),
  ],
})
export class KlmrPrestartJobcardPageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-prestart-jobcard/klmr-prestart-jobcard.module.ts